/* eslint-disable max-len */
import React, { useContext,useEffect, useState } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import { setOrganizationSearch,resetOrganizationSearch } from '../../../../redux/organizationSearchSlice';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import DateInput from '../../../../components/DateField';

export default function OrganizationAdvancedSearch({handleOnSubmit,emptyField,setEmptyField}) {
    const organizationSearch = useSelector(state => state.organizationSearchData);
    
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state.organizationSearchData.orgsearchApplied);

    
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
        // Allow only numeric input for the "main number" field
        if (id === 'main_number'||id==='main_number_code') {
        // Use a regular expression to allow only numbers
            updatedValue = updatedValue.replace(/\D/g, ''); // Removes any non-numeric characters
        }


        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }
    
        const updatedState = { ...organizationSearch, [id]: updatedValue };

        // Uncheck `main_number_inverse` if both main number fields are empty
        if ((id === 'main_number' || id === 'main_number_code') &&
         updatedState.main_number === '' && 
         updatedState.main_number_code === '' &&
         updatedState.main_number_inverse === 'true') 
        {
            updatedState.main_number_inverse = '';
        }

        // Default handling for other fields
        if (!['main_number', 'main_number_code'].includes(id) && 
         updatedValue === '' && 
         updatedState[`${id}_inverse`] === 'true') 
        {
            updatedState[`${id}_inverse`] = '';
        }
    
    
        // Update the organizationSearch state and dispatch to Redux
        setOrganizationSearch(updatedState);
        dispatch(setOrganizationSearch(updatedState));
    };
    
    
    

    const handleCheckboxChange = (e, field) => {
        const { checked, id } = e.target; // Use `id` to identify the checkbox
    
        // Create an updated organizationSearch state
        let updatedState = { ...organizationSearch };
    
        if (id === 'value_added_inverse') {
            // Handle value_added_inverse checkbox
            updatedState.value_added_inverse = checked ? 'true' : '';
        } else if (id === 'direct_billing_inverse') {
            // Handle direct_billing_inverse checkbox
            updatedState.direct_billing_inverse = checked ? 'true' : '';
        } else if (id.startsWith('value_added')) {
            // Handle value_added checkboxes
            const updatedValueAdded = checked
                ? [...(organizationSearch.value_added || []), field]
                : (organizationSearch.value_added || []).filter((value) => value !== field);
    
            // Reset value_added_inverse if the array is empty
            if (updatedValueAdded.length === 0) {
                updatedState.value_added_inverse = '';
            }
    
            updatedState.value_added = updatedValueAdded;
        } else if (id.startsWith('direct_billing')) {
            // Handle direct_billing checkboxes
            const updatedDirectBilling = checked
                ? [...(organizationSearch.direct_billing || []), field]
                : (organizationSearch.direct_billing || []).filter((value) => value !== field);
    
            // Reset direct_billing_inverse if the array is empty
            if (updatedDirectBilling.length === 0) {
                updatedState.direct_billing_inverse = '';
            }
    
            updatedState.direct_billing = updatedDirectBilling;
        } else {
            // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';
        }
    
        // Dispatch the updated state
        dispatch(setOrganizationSearch(updatedState));
    };
    
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetOrganizationSearch());
        }

    };

    const isApplyButtonDisabled = () => {
        return Object.entries(organizationSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetOrganizationSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Validate input: only numbers, and apply limits
        const validatedDay = /^[0-9]*$/.test(newDate.day) && newDate.day <= 31 ? newDate.day : '';
        const validatedMonth = /^[0-9]*$/.test(newDate.month) && newDate.month <= 12 ? newDate.month : '';
        const validatedYear = /^[0-9]*$/.test(newDate.year) ? newDate.year : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        dispatch(setOrganizationSearch({
            ...organizationSearch,
            created_day: validatedDay,
            created_month: validatedMonth,
            created_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            created_date_inverse: isDateCleared ? '' : organizationSearch.created_date_inverse,
        }));
    };

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        dispatch(resetOrganizationSearch());

        const params = Object.fromEntries(searchParams);
        if (params.search) {
            const searchDecoded = decodeURIComponent(params.search);
    
            // Temporary state object
            const updatedState = {};
    
            // Helper function to extract a single field's value safely
            const extractField = (fieldName) => {
                const match = searchDecoded.match(
                    new RegExp(`${fieldName}=(ne:)?([^;]+)(;|$)`) // Ensures it stops before another field
                );
                if (match) {
                    return {
                        isInverse: !!match[1],
                        value: match[2].trim(),
                    };
                }
                return null;
            };
    
            // Handle `organization_id` (mapped to `user_id` and `user_id_inverse`)
            const organizationIdData = extractField('organization_id');
            if (organizationIdData) {
                updatedState.user_id = organizationIdData.value === '__NULL__' ? '-' : organizationIdData.value;
                updatedState.user_id_inverse = organizationIdData.isInverse ? 'true' : '';
            }
    
            // Handle `organization_name` (mapped to `orgname` and `orgname_inverse`)
            const organizationNameData = extractField('organization_name');
            if (organizationNameData) {
                updatedState.orgname = organizationNameData.value === '__NULL__' ? '-' : organizationNameData.value;
                updatedState.orgname_inverse = organizationNameData.isInverse ? 'true' : '';
            }
    
            // Handle `organization_main_country_code-main_number`
            const mainNumberData = extractField('organization_main_country_code-main_number');
            if (mainNumberData) {
                const rawNumber = mainNumberData.value;
    
                // Remove "+" from the country code and split the value
                const [rawMainNumberCode, rawMainNumber] = rawNumber.split('-');
                const mainNumberCode = rawMainNumberCode?.replace('+', '') || '';
                const mainNumber = rawMainNumber?.replace('-', '').trim() || '';
    
                updatedState.main_number_code = mainNumberCode;
                updatedState.main_number = mainNumber;
                updatedState.main_number_inverse = mainNumberData.isInverse ? 'true' : '';
            }
    
            // Handle `search_mode`
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or';
            }
    
            // Dispatch the action with the updated state
            setTimeout(() => {
                dispatch(setOrganizationSearch(updatedState));
            }, 0);
        }
    }, [isAdvancedSearchOpen]);
    
    
    



    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={organizationSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${organizationSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!organizationSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!organizationSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={organizationSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={organizationSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Organization Name"}
                                    placeholder={"Enter organization name"}
                                    id={"orgname"}
                                    data_testid={"orgname"}
                                    htmlFor={"orgname"}
                                    value={organizationSearch?.orgname}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='orgname_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'orgname_inverse')}
                                        checked={organizationSearch?.orgname_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.orgname?.trim()===""}
                                    />
                                    <label htmlFor='orgname_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Main Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"main_number_code"}
                                            data_testid={"main_number_code"}
                                            htmlFor={"main_number_code"}
                                            value={organizationSearch?.main_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"main_number"}
                                        data_testid={"main_number"}
                                        htmlFor={"main_number"}
                                        value={organizationSearch?.main_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='main_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'main_number_inverse')}
                                        checked={organizationSearch?.main_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.main_number_code?.trim()==="" && organizationSearch?.main_number?.trim()===""}
                                    />
                                    <label htmlFor='main_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Value Added</p>
                                <div className='flex items-center'>
                                    <div className='p-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='value_added_true'
                                            onChange={(e) => handleCheckboxChange(e, 'true')}
                                            checked={organizationSearch?.value_added?.includes('true')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='value_added_true' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            True
                                        </label>
                                    </div>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='value_added_false'
                                            onChange={(e) => handleCheckboxChange(e, 'false')}
                                            checked={organizationSearch?.value_added?.includes('false')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='value_added_false' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            False
                                        </label>
                                    </div>
                                </div>


                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='value_added_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'value_added_inverse')}
                                        checked={organizationSearch?.value_added_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.value_added?.length === 0}
                                    />
                                    <label htmlFor='view' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Direct Billing</p>
                                <div className='flex items-center'>
                                    <div className='p-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='direct_billing_true'
                                            onChange={(e) => handleCheckboxChange(e, 'true')}
                                            checked={organizationSearch?.direct_billing?.includes('true')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='direct_billing_true' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            True
                                        </label>
                                    </div>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='direct_billing_false'
                                            onChange={(e) => handleCheckboxChange(e, 'false')}
                                            checked={organizationSearch?.direct_billing?.includes('false')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='direct_billing_false' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            False
                                        </label>
                                    </div>
                                </div>


                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='direct_billing_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'direct_billing_inverse')}
                                        checked={organizationSearch?.direct_billing_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.direct_billing?.length === 0}
                                    />
                                    <label htmlFor='view' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Created Date'}
                                    date={{
                                        day: organizationSearch.created_day,
                                        month: organizationSearch.created_month,
                                        year: organizationSearch.created_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                    idPrefix="created"
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='created_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        checked={organizationSearch.created_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={organizationSearch?.created_day?.trim()==="" || organizationSearch?.created_month?.trim()==="" || organizationSearch?.created_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
